<template>
    <slot></slot>
</template>

<script>
export default {
    name: "ClickOutsideObserver",
    emits: ['click-outside', 'close'],
    props: {
        isActive: {
            type: Boolean,
            default: false // Whether the observer should be active
        },
        ignoredClassList: {
            type: Array,
            default: []
        },
        forceCloseOnClickOutside: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.isActive) {
            document.addEventListener("mousedown", this.handleClickOutside);
        }
    },
    beforeUnmount() {
        this.cleanupObserver(); // Clean up event listeners
    },
    watch: {
        isActive(newVal) {
            if (newVal) {
                document.addEventListener("mousedown", this.handleClickOutside);
            } else {
                this.cleanupObserver();
            }
        }
    },
    methods: {
        handleClickOutside(event) {
            const observedElement = this.$el?.nextElementSibling;
            const isClickInsideIgnoredElement = this.ignoredClassList.some(className =>
                event.target.closest(`.${className}`)
            );
            if (
                observedElement &&
                !observedElement.contains(event.target) &&
                !isClickInsideIgnoredElement &&
                (!this.$store.state.activeModal || this.forceCloseOnClickOutside)
            ) {
                this.$emit("click-outside", event); // Emit event when clicking outside
            }
        },
        cleanupObserver() {
            document.removeEventListener("mousedown", this.handleClickOutside);
        }
    }
};
</script>